"use strict";var e=require("@apollo/client"),o=e.gql`
  fragment Taxes on ProductTaxModel {
    taxId
    taxName
    taxType
    taxValue
    taxSubTotal
  }
`,t=e.gql`
  ${o}
  fragment PromotionCondition on PromotionCondition {
    quantity
    price
    priceBeforeTaxes
    taxTotal
    taxes {
      ...Taxes
    }
  }
`,a=e.gql`
  ${t}
  fragment Promotion on Promotion {
    type
    isActive
    conditions {
      ...PromotionCondition
    }
    description
    endDateTime
    startDateTime
  }
`,i=e.gql`
  fragment CatalogProductFormatModel on CatalogProductFormatModel {
    format
    equivalence
    unitEquivalence
    clickMultiplier
    minQty
    maxQty
  }
`,r=e.gql`
  fragment CatalogProductTagModel on CatalogProductTagModel {
    description
    enabled
    textColor
    filter
    tagReference
    backgroundColor
    name
  }
`,n=e.gql`
  fragment CategoryFields on CategoryModel {
    active
    boost
    hasChildren
    categoryNamesPath
    isAvailableInHome
    level
    name
    path
    reference
    slug
    photoUrl
    imageUrl
    shortName
    isFeatured
    isAssociatedToCatalog
  }
`,l=e.gql`
  fragment NutritionalDetailsInformation on NutritionalDetailsInformation {
    servingName
    servingSize
    servingUnit
    servingsPerPortion
    nutritionalTable {
      nutrientName
      quantity
      unit
      quantityPerPortion
      dailyValue
    }
    bottomInfo
  }
`,s=e.gql`
  fragment PromotedModel on PromotedModel {
    isPromoted
    onLoadBeacon
    onClickBeacon
    onViewBeacon
    onBasketChangeBeacon
    onWishlistBeacon
  }
`,g=e.gql`
  fragment Promotions on PromotionV2 {
    type
    description
    promotionReference
    startDateTime
    endDateTime
    isActive
    conditions {
      field
      operator
      values
      value
    }
    benefit {
      type
      label
      value
      values
      imagesURL
    }
  }
`,c=e.gql`
  fragment SpecificationModel on SpecificationModel {
    title
    values {
      label
      value
    }
  }
`,d=e.gql`
  ${n}
  ${r}
  ${i}
  ${a}
  ${s}
  ${c}
  ${l}
  ${o}
  ${g}
  fragment CatalogProductModel on CatalogProductModel {
    name
    price
    photosUrl
    unit
    subUnit
    subQty
    description
    sku
    ean
    maxQty
    minQty
    clickMultiplier
    nutritionalDetails
    isActive
    slug
    brand
    stock
    securityStock
    boost
    isAvailable
    location
    priceBeforeTaxes
    taxTotal
    promotion {
      ...Promotion
    }
    taxes {
      ...Taxes
    }
    categories {
      ...CategoryFields
    }
    categoriesData {
      ...CategoryFields
    }
    formats {
      ...CatalogProductFormatModel
    }
    tags {
      ...CatalogProductTagModel
    }
    specifications {
      ...SpecificationModel
    }
    promoted {
      ...PromotedModel
    }
    score
    relatedProducts
    ingredients
    stockWarning
    nutritionalDetailsInformation {
      ...NutritionalDetailsInformation
    }
    productVariants
    isVariant
    isDominant
    promotions {
      ...Promotions
    }
    seals
    previousPrice
    previousPricePerSubUnit
    pricePerSubUnit
    hasAgeRestriction
    type
  }
`,m=e.gql`
  ${n}

  fragment CategoriesRecursive on CategoryModel {
    subCategories {
      ...CategoryFields
      subCategories {
        ...CategoryFields
        subCategories {
          ...CategoryFields
        }
      }
    }
  }

  fragment CategoryModel on CategoryModel {
    ...CategoryFields
    ...CategoriesRecursive
  }
`;exports.C=d,exports.P=s,exports.a=m,exports.b=a;